// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rkofajl{border-radius:var(--ds-radius-small,3px)}._19bvv77o{padding-left:var(--ds-space-025,2px)}\n._bfhk1v65{background-color:var(--_1kd7x7o)}\n._ca0qidpf{padding-top:0}\n._jqf61teg{label:tooltip-shortcut}\n._n3tdidpf{padding-bottom:0}\n._u5f3v77o{padding-right:var(--ds-space-025,2px)}", ""]);
// Exports
module.exports = exports;
